module.exports = __webpack_public_path__ + "img/gold3.62dd7c51.png";